import { render, staticRenderFns } from "./VisorPdf.vue?vue&type=template&id=1c6065f9&scoped=true"
import script from "./VisorPdf.vue?vue&type=script&lang=js"
export * from "./VisorPdf.vue?vue&type=script&lang=js"
import style0 from "./VisorPdf.vue?vue&type=style&index=0&id=1c6065f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6065f9",
  null
  
)

export default component.exports